import React from "react";
import Navbar from "../components/Navbar";
import AboutHeroSection from "../components/AboutHero";
import CertificateSlider from "../components/SliderCerticate";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const CertifcatePage = () => {
  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Registerations | VisionBird Technologies</title>
        <meta
          name="description"
          content="View VisionBird Technologies certifications and registrations including P@SHA, PSEB, PSW, GtCCI, FBR and international audit verification."
        />
      </Helmet>

      <Navbar />
      <AboutHeroSection
        title="CERTIFICATIONS / "
        highlight="REGISTRATIONS"
        description={`We are proudly registered with P@SHA (Pakistan Software Houses for IT
                      and ITeS), PSEB (Pakistan Software Export Board),PESSI (Punjab Employees Social Security Institution), PSW (Pakistan Single 
                      Window), GtCCI (Gujrat Chamber of Commerce and Industries), FBR 
                      (Federal Board of Revenue, Government of Pakistan) and Internationally 
                      Audited by ICIL Ltd.`}
        image="/assets/Images/Website designer-pana 1 (3).png"
      />
      <CertificateSlider />
      <Footer />
    </>
  );
};

export default CertifcatePage;